/** Silhueta padrão do veículo (placeholder da Etapa 1 quando nenhum modelo está
    selecionado). SVG inline — sem dependência externa; a cor herda `--text-body`. */
export const CarSilhouette = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 640 260"
    role="img"
    aria-label="Veículo"
    width="100%"
    style={{ maxHeight: 220, display: "block" }}
  >
    <g fill="var(--td-placeholder-fill, var(--text-body, #94a3b8))" opacity="0.85">
      {/* corpo */}
      <path d="M64 170c-10 0-18-2-24-8-6-6-8-14-6-22l8-30c3-11 12-19 23-22l58-14c8-2 15-6 22-11l38-27c14-10 31-16 49-17l96-4c26-1 51 8 70 26l40 38c6 6 14 9 22 10l50 6c16 2 30 12 37 27 4 9 5 18 3 27-2 9-10 15-19 15h-38a44 44 0 00-88 0H236a44 44 0 00-88 0H64z" />
    </g>
    {/* rodas */}
    <circle cx="192" cy="188" r="34" fill="var(--td-placeholder-fill, var(--text-body, #94a3b8))" />
    <circle cx="192" cy="188" r="16" fill="var(--general-background, #f1f5f9)" />
    <circle cx="472" cy="188" r="34" fill="var(--td-placeholder-fill, var(--text-body, #94a3b8))" />
    <circle cx="472" cy="188" r="16" fill="var(--general-background, #f1f5f9)" />
  </svg>
)
